import React, { Component } from 'react';
import * as actions from 'actions';
import { connect } from 'react-redux';

import VideoDocumentList from './VideoDocumentList'

import MessageBackEnd from 'utils/ChatBackend';
const { loadMessages, sendMessage } = MessageBackEnd;


import { Radio, RadioGroup } from 'react-radio-group';
import isEqual from 'lodash/isEqual';
import uniq from 'lodash/uniq';

import AddPhoto from 'material-ui/svg-icons/image/add-a-photo';
import Send from 'material-ui/svg-icons/content/send';
import { getMaxHeightVideoDocuments } from 'utils/layoutUtils';
import MessageSubmitFormSC from '../Chat/MessageSubmitFormSC';

import { constants } from 'constants/index';
import SendMessageButton from '../Button/SendMessageButton';

import ExifOrientationImg from 'react-exif-orientation-img';
import SpaceAround from '../Positioners/SpaceAround';
import Close from 'material-ui/svg-icons/navigation/close';
import TextButton from '../Button/TextButton';


const moment = require('moment-timezone');

class VideoDocuments extends Component {

    constructor(props) {
        super(props);
        
        this.state = {
            allowedToLoadPrevious: false,
            buttonColor: '#C6CACC',
            channel: null,
            documentLink: '',
            documentTitle: '',
            inputHeight: 80,
            loadButton: false,
            loadSpinner: false,
            loadingPrevious: false,
            messageAttributes: {},
            messages: [],
            messagesLoaded: false,
            photos: [],
            selectedLinkType: '',
            service: null,
            shouldRenderCameraScreen: false,
            videoLink: '',
            videoTitle: '',
        };

        let mounted = false;
    } 
    
    componentDidMount() {
        const { channel, user, service } = this.props;
        
        // const channel = (channel) ? channel : null;
        // console.log('%cCURRENT CHANNEL','color: aqua', channel);

        // LOAD ALL MESSAGES FROM DB ON MOUNT
        this.props.loadMessages(this.loadMessages, user.uid, service._id, service.provider, channel, 'link')
        .then((messages) => {
            // console.log('LOGS ON DID MOUNT', messages);
            
            this.loadMessages(messages);
            this.setState({
                allowedToLoadPrevious: true,
                messagesLoaded: true
            })
        })
        .catch(console.log);
    }

    componentWillReceiveProps(nextProps) {
        const { user, service, channel } = nextProps;
        if (this.props.channel !== nextProps.channel) {
            // ERASE MESSAGES FROM PREVIOUS SELECTED THREAD
            this.setState({
                messages: []
            })
            
            // LOAD MESSAGES FOR WHEN NEW CLIENT/SERVICE ARE SELECTED
            this.props.loadMessages(this.loadMessages, user.uid, service._id, service.provider, channel, 'link')
            .then((messages) => {
                // console.log('MESSAGES @ LOAD MESSAGES', messages, typeof messages);
                
                this.loadMessages(messages);
                this.setState({
                    allowedToLoadPrevious: true,
                    messagesLoaded: true
                })
                // this.scrollToBottom();
            })
            .catch(console.log);
        }
    }

    onMessageSubmit(e) {
        e.preventDefault();
        
        const { documentLink, documentTitle, videoLink, videoTitle } = this.state;
        const documentInputsFilled = documentTitle.length > 0 && documentLink.length > 0;
        const videoInputsFilled = videoTitle.length > 0 && videoLink.length > 0;

        if (!(documentInputsFilled) && !(videoInputsFilled)) {
          alert('All fields are required.'); 
            return false;
        }
        
        let linkType = null;
        
        if (documentInputsFilled) {
            linkType = 'document';
        } 
        if (videoInputsFilled) {
            linkType = 'video';
        }

        // SEND LINK DETAILS
        this.pushMessage(
            (documentInputsFilled)
            ? {
                documentLink,
                documentTitle,
                linkType,
            }
            : {
                linkType,
                videoLink,
                videoTitle,
            }
        );
        
        // RESET INPUTS
        this.setState({
            documentLink: '',
            documentTitle: '',
            videoLink: '',
            videoTitle: '',
        });
        
        return true; // ?
    }

    pushMessage({ videoLink, videoTitle, documentLink, documentTitle, linkType }) {
        const prevState = this.state;
        const { user, channel, selectedClient, service } = this.props;
        
        const commonLinkData = {
            createdAt: moment.utc().format('x'),
            receiverId: selectedClient.uid,
            senderId: user.uid,
            serviceId: service._id,
            threadId: channel,
            type: 'link',
        };
        
        let typeSpecificData;

        if (linkType === 'document') {
            typeSpecificData = {
                linkData: {
                    documentLink,
                    documentTitle,
                    linkType,
                }
            };
        }
        
        if (linkType === 'video') {
            typeSpecificData = {
                linkData: {
                    linkType,
                    videoLink,
                    videoTitle,
                }
            };
        }

        const data = {
            ...commonLinkData,
            ...typeSpecificData,
        }

        sendMessage(data);

        prevState.messages.push(data);
        this.setState(this.state);
        this.setState({
            shouldScrollToBottom: true
        });
    }

    resetShouldScrollToBottom = () => {
        this.setState({
            shouldScrollToBottom: false
        })
    }

    scrollToBottom = () => {
        // TODO: ========= 
        // might be good to show an indicator when a new message arrives while the user is scrolled up looking at chat history so they know to scroll down to view the new message. 
        // I dont like the idea of forcing a scroll down when they are viewing old messages.
        // They can click on the indicator to scroll to the bottom/new messages and hide the indicator
        // ===============
        const scrollHeight = this.chat.scrollHeight;
        const height = this.chat.clientHeight;
        const maxScrollTop = scrollHeight - height;
        this.chat.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
    }

    loadMoreMessages = () => {
        // console.log('MESSAGES _id', this.state.messages[0]._id, this.state.messages[0], this.state.messages);
        
        return new Promise((resolve, reject) => {
            this.props.loadPastMessages((messArray) => {
                // console.log('messArray', messArray);
                resolve(messArray);
            }, this.props.service.provider, this.props.messagesRedux && this.props.messagesRedux[0]._id, this.props.channel, 'nutritionLog')
        });
    };

    getSenderName = (message) => {
        return (!this.props.client.provider && !this.props.selectedClient)
            ? `${this.props.client.firstName} ${this.props.client.lastName}` 
            : `${this.props.selectedClient.firstName} ${this.props.selectedClient.lastName}`;
    }

    loadMessages = (messages) => {
        console.log('MESSAGES @ loadMessages @ VideoDocument', messages);
        let restructuredMessages = this.getRestructuredMessages({messages: messages});
        // console.log('RESTRUCTURED MESSAGES', restructuredMessages);
        
        this.setState((prevState) => {
            if (prevState.messages.length > 19) {
                // prevState.messages.splice(prevState.messages.length - 1, 1); // prevents duplicate
                return {
                    loadButton: true,
                    messages: [...prevState.messages, ...restructuredMessages],
                };
            } else {
                return {
                    messages: (prevState && prevState.messages.length > 0) ? [...prevState.messages, ...restructuredMessages] : [...restructuredMessages],
                };
            }
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.messages.length > 0 && this.state.messages.length > 0 && this.state.messages.length === prevState.messages.length) {
            // console.log('DONE LOADING MESSAGES');
        }
    }

    handlePhotoUpload = (event) => {
        // Show photo thumb that was uploaded
        const file = event.target.files[0];
        const photoPreviewURL = URL.createObjectURL(file);

        this.setState({
            photoUpload: {
                file: file,
                preview: photoPreviewURL,
            }
        })
        // console.log('PHOTO PREVIEW', photoPreviewURL);
    }

    handleLinkTypeSelect = (e) => {
        // console.log( e, this.state.selectedLinkType);
        this.setState({
            selectedLinkType: e
        })
    }

    setDocumentTitle = (e) => {
        // console.log('Title', e.target.value);
        this.setState({
            documentTitle: e.target.value
        });
    }
    
    setDocumentLink = (e) => {
        // console.log('Link', e.target.value);
        this.setState({
            documentLink: e.target.value
        });
    }
    
    setVideoTitle = (e) => {
        // console.log('Title', e.target.value);
        this.setState({
            videoTitle: e.target.value
        });
    }
    
    setVideoLink = (e) => {
        // console.log('Link', e.target.value);
        this.setState({
            videoLink: e.target.value
        });
    }

    handleSetButtonColor = (e) => {
        if (e.target.value.length > 0){
         this.setState({
             buttonColor: '#4AC4D1'
         })
        }else {
         this.setState({
             buttonColor: '#C6CACC'
         })
        }
     }

     onClickClose = (e) => {
        this.setState({
            selectedLinkType: ''
        })
     }

    render() {
        const { channel, userData, selectedClient, service } = this.props;
        const { photoUpload } = this.state;
        if (this.state.messages && this.state.messages.length > 0 ) {
            // console.log('LOAD MORE?', this.state.messages[this.state.messages.length - 1].id, this.state.messages.length, this.state.messages.length - 1 /*this.state.messages[this.state.messages.length - 1].id*/);
        }        return (
            <div id={'outerDocContainerStyles'} style={styles.outerChatContainerStyles}>
                <div id={'innerDocContainerStyles'} style={styles.innerChatContainerStyles}>
                    <div style={{padding: '0px 20px', maxWidth: '100%', display: 'flex', flex: 1, overflow: 'scroll' }}>
                    { userData &&
                        <VideoDocumentList
                            maxHeight={ getMaxHeightVideoDocuments(this.state, userData, this.state.inputHeight)}
                            messages={ this.state.messages } // Boolean: list of message object
                            showSenderName
                            loadMoreMessages={ this.loadMoreMessages }
                            allowedToLoadPrevious={ this.state.allowedToLoadPrevious }
                            messagesLoaded={ this.state.messagesLoaded }
                            shouldScrollToBottom={ this.state.shouldScrollToBottom }
                            resetShouldScrollToBottom={ this.resetShouldScrollToBottom }
                            userData={ userData }
                            selectedClient={ selectedClient }
                            selectedService={ service }
                            channel={ channel }
                            provider={(service) ? service.provider : null}
                        />
                    }
                    </div>
                    { userData.provider &&
                        <MessageSubmitFormSC onSubmit={e => this.onMessageSubmit(e)} flexDirection={'column'} maxWidth={constants.layout.InteractionPanel.maxWidth}>
                            <div style={{ padding: '0px 10px', fontSize: constants.text.baseFontStyles.fontSize }}>
                                <div style={{ display: 'flex', flexDirection: 'row'}}>
                                    <label>What type of expert content are you sending? (Select One)</label>
                                    { this.state.selectedLinkType !== '' &&
                                        <TextButton
                                            onClick={this.onClickClose}
                                            style={{ padding: '10px 10px' }}
                                        >
                                            <Close color={'gray'}/>
                                        </TextButton>
                                    }
                                </div>
                                <div style={{ display: 'flex', height: 50, flex: 1, width: '100%', marginBottom: 15}}>
                                    <label style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1, backgroundColor: (this.state.selectedLinkType === 'document' ? constants.color.secondary : 'grey'), color: 'white', marginRight: 10, borderRadius: 10 }} htmlFor="document">
                                        DOCUMENT
                                    </label>
                                    <label style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1, backgroundColor: (this.state.selectedLinkType === 'video' ? constants.color.secondary : 'grey'), color: 'white', marginRight: 10, borderRadius: 10 }} htmlFor="video">
                                        VIDEO
                                    </label>
                                </div>
                            </div>
                            <RadioGroup style={{ display: 'none' }} name="link" selectedValue={this.state.selectedLinkType} onChange={this.handleLinkTypeSelect}>
                                <Radio id="document" value="document" />DOC {/* Hidden radio lables */}
                                <Radio id="video"value="video" />VID {/* Hidden radio lables */}
                            </RadioGroup>
                            {   this.state.selectedLinkType === 'document' &&
                                <div id={'outerInputStyles'} style={styles.outerInputStyles}>
                                    <div id={'iconContainerStyles'} style={styles.iconContainerStyles}>
                                        <ExifOrientationImg
                                            src="https://firebasestorage.googleapis.com/v0/b/cyno-telephysio-pilot.appspot.com/o/interactionPanel%2FdocVidSharing%2FBox.png?alt=media&token=9a5ad8d7-757e-40c4-a1a1-e93f8c8dba23"
                                            alt="box"
                                            style={styles.iconStyles}
                                        />
                                        <ExifOrientationImg
                                            src="https://firebasestorage.googleapis.com/v0/b/cyno-telephysio-pilot.appspot.com/o/interactionPanel%2FdocVidSharing%2FDropBox.png?alt=media&token=e5e1f2e0-2beb-48d5-8192-d44bdee9ae7e"
                                            alt="dropBox"
                                            style={styles.iconStyles}
                                        />
                                        <ExifOrientationImg
                                            src="https://firebasestorage.googleapis.com/v0/b/cyno-telephysio-pilot.appspot.com/o/interactionPanel%2FdocVidSharing%2FGoogleDrive.png?alt=media&token=8f164bce-551f-442a-8834-68d18a37e1de"
                                            alt="googleDrive"
                                            style={styles.iconStyles}
                                        />
                                    </div>
                                    <div style={styles.inputsAndButton}>
                                        <div style={styles.inputfields}>
                                            <input 
                                                type="text"
                                                placeholder="Give your document a title..."
                                                
                                                style={ styles.chatInputStyles }
                                                onChange={ this.setDocumentTitle }
                                                value={this.state.documentTitle}
                                            />
                                            <input
                                                onKeyUp={ this.handleSetButtonColor }
                                                placeholder="Link from: Google Drive, box, dropbox."
                                                style={ styles.chatInputStyles }
                                                onChange={ this.setDocumentLink }
                                                value={this.state.documentLink}
                                            />
                                        </div>
                                        <button 
                                            disabled={ this.state.documentTitle.length === 0 || this.state.documentLink.length === 0 } 
                                            type="submit" 
                                            style={styles.wrappingButtonStyles}
                                        >
                                            <SendMessageButton buttonBackgroundColor={ this.state.buttonColor }/>
                                        </button>
                                    </div>
                                </div>
                            }
                            
                            {   this.state.selectedLinkType === 'video' &&
                                <div id={'outerInputStyles'} style={styles.outerInputStyles}>
                                    <div id={'iconContainerStyles'} style={styles.iconContainerStyles}>
                                        <ExifOrientationImg
                                            src="https://firebasestorage.googleapis.com/v0/b/cyno-telephysio-pilot.appspot.com/o/interactionPanel%2FdocVidSharing%2FVimeo.png?alt=media&token=a8cc7533-9354-4597-99bb-dc91bb13becf"
                                            alt="vimeo"
                                            style={styles.iconStyles}
                                        />
                                        <ExifOrientationImg
                                            src="https://firebasestorage.googleapis.com/v0/b/cyno-telephysio-pilot.appspot.com/o/interactionPanel%2FdocVidSharing%2FYoutube.png?alt=media&token=abb802e0-b8a5-42e3-a3ea-6a2ce82840a0"
                                            alt="youTube"
                                            style={styles.iconStyles}
                                        />
                                    </div>
                                    <div style={styles.inputsAndButton}>
                                        <div style={styles.inputfields}>
                                            <input 
                                                placeholder="Give your video a title..."
                                                style={ styles.chatInputStyles }
                                                onChange={ this.setVideoTitle } // saves input text to state
                                                value={this.state.videoTitle} // puts the new state back into the input
                                            />
                                            <input
                                                onKeyUp={ this.handleSetButtonColor }
                                                placeholder="Link from: YouTube, Vimeo"
                                                style={ styles.chatInputStyles }
                                                onChange={ this.setVideoLink } // saves input text to state
                                                value={this.state.videoLink} // puts the new state back into the input
                                            />
                                        </div>
                                        <button
                                            disabled={ this.state.videoTitle.length === 0 || this.state.videoLink.length === 0 } 
                                            type="submit" 
                                            style={styles.wrappingButtonStyles}
                                        >
                                            <SendMessageButton buttonBackgroundColor={ this.state.buttonColor }/>
                                        </button>
                                    </div> 
                                </div>
                            }
                        </MessageSubmitFormSC>
                    }
                </div>
        </div>
        );
    }
}

// const { width: viewportWidth, height: viewportHeight } = Dimensions.get('window');
const styles = {
    button: {
        backgroundColor: '#fff',
        borderColor: '#1D2129',
        borderRadius: 20,
        borderStyle: 'solid',
        borderWidth: 2,
        color: '#1D2129',
        fontSize: 18,
        fontWeight: '300',
        paddingBottom: 8,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 8,
    },
    chatInputStyles: {  
        border: 'none',
        borderTop: '1px solid #ddd',
        fontSize: '16px',
        padding: '10px',
        paddingLeft: '30px',
        // width: 'calc(100% - 50px)',
    },
    iconContainerStyles: {  
        alignItems: 'center',
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-around',
        paddingBottom: 20,
        // alignSelf: 'center',
        // maxWidth: 200
    },
    iconStyles:{
        height: 30,
    },
    outerChatContainerStyles: {
        display: 'flex',
        flex: 1,
        justifyContent: 'flex-end',
        overflow: 'scroll'
    },
    innerChatContainerStyles: {
        display: 'flex',
        flexFlow: 'column nowrap',
        justifyContent: 'flex-end',
        flex: 1,
        alignItems: 'stretch',
        overflow: 'scroll'
    },
    inputfields:{
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
    },
    inputsAndButton:{
        display: 'flex',
        flexDirection: 'row',
    },
    outerInputStyles: {  
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    selected: {
        backgroundColor: '#0084FF',
        borderColor: '#0084FF',
        color: '#fff',
    },
    wrappingButtonStyles:{ 
        alignItems: 'center',
        backgroundColor: 'transparent', 
        borderWidth: 0, 
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
        maxWidth: 60,
        padding: 20,
    },
}

const mapStateToProps = ({ chat, client, provider }) => {
    // console.log('GOT NEW CHANNEL?', chat.messageThread);
    const { linkMessages, messageThread } = chat;
    return {
        channel: messageThread,
        messagesRedux: linkMessages,
        selectedClient: provider.selectedClient,
        userData: client.clientData,
    };
};

export default connect(mapStateToProps, actions)(VideoDocuments);


// WEBPACK FOOTER //
// ./src/js/components/VideoDocumentSharing/VideoDocuments.jsx